"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortBy = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const t = require("io-ts");
const _ActionTypes = require("./actionTypes");
const _Actions = require("./actions");
const TypesLib = require("@caddigital/sok-types");
const errorHandling_1 = require("../../../utils/errorHandling");
const iMinimal = t.union([
    TypesLib.File._iRevisionMinimal,
    TypesLib.File._iFolderMinimal
]);
const sortBy = (column) => (order) => (a, b) => {
    if (a.type !== b.type) {
        if (a.type === 'FOLDER') {
            return -1;
        }
        else if (b.type === 'FOLDER') {
            return 1;
        }
    }
    if (column === 'name-meta') {
        return order === 'desc'
            ? b.name.localeCompare(a.name)
            : a.name.localeCompare(b.name);
    }
    let al;
    let bl;
    if (typeof a.customMeta === 'object') {
        al = a.customMeta;
        bl = b.customMeta;
    }
    else {
        al = a.customMeta.reduce((p, curr) => {
            p[curr.identifier] = curr.value;
            return p;
        }, {});
        bl = b.customMeta.reduce((p, curr) => {
            p[curr.identifier] = curr.value;
            return p;
        }, {});
    }
    // if no column to make comparision against, compare using the name
    if (!al[column] && !bl[column]) {
        return a.name.localeCompare(b.name);
    }
    else if (al[column] === null) {
        return 1;
    }
    else if (bl[column] === null) {
        return -1;
    }
    return al[column] < bl[column]
        ? order === 'asc'
            ? 1
            : -1
        : order === 'asc'
            ? -1
            : 1;
};
exports.sortBy = sortBy;
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const Actions = _Actions.default(namespace);
    function fetchTree(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.FETCH_TREE_REQUEST), (0, operators_1.mergeMap)(({ payload }) => {
            const queryParams = [
                `hierarchyType=${payload.hierarchyType}`,
                `includeSelf=${payload.includeSelf}`,
                `includeSubFolders=${payload.includeSubFolders ? payload.includeSubFolders : false}`
            ];
            if (payload.includeSubFolders &&
                payload.subFoldersDepth !== undefined) {
                queryParams.push(`subFoldersDepth=${payload.subFoldersDepth}`);
            }
            if (payload.markAutomaticOrderFolders) {
                queryParams.push(`markAutomaticOrderFolders=${payload.markAutomaticOrderFolders.toString()}`);
            }
            return ajax({
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: getToken()
                },
                method: 'GET',
                url: `${baseUrl}api/files/project/${payload.node.project}/${payload.node.id}?${queryParams.join('&')}`
            }).pipe((0, operators_1.mergeMap)((data) => t
                .intersection([
                t.interface({
                    files: t.array(iMinimal),
                    total: t.number,
                    path: t.array(iMinimal)
                }),
                t.partial({
                    node: iMinimal
                })
            ])
                .decode(data.response)
                .fold((e) => (0, rxjs_1.of)(Actions.fetchTreeFailure()), (res) => {
                return (0, rxjs_1.of)(Actions.fetchTreeSuccess({
                    total: res.total,
                    files: res.files.sort((0, exports.sortBy)('name-meta')('asc')),
                    types: payload.types,
                    node: res.node || payload.node,
                    path: res.path
                }));
            })), (0, operators_1.catchError)((e) => {
                console.error(e);
                return (0, rxjs_1.of)(Actions.fetchTreeFailure());
            }));
        }));
    }
    function copyFiles(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.COPY_FILES_REQUEST), (0, operators_1.mergeMap)((payload) => {
            const body = {
                uuids: payload.files.map((f) => f.getValue().uuid),
                ignored: payload.ignored
                    ? payload.ignored.map((f) => f.getValue().uuid)
                    : [],
                destination: payload.target.uuid,
                revisionDuplicates: payload.revisionDuplicates
            };
            if (payload.mode === 'IMPORT' && payload.groups) {
                body['groups'] = payload.groups.map((g) => g.id);
            }
            return ajax({
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: getToken()
                },
                method: 'POST',
                timeout: 5 * 60 * 1000,
                body: body,
                url: `${baseUrl}api/files/${payload.mode.toLowerCase()}`
            }).pipe((0, operators_1.mergeMap)(() => (0, rxjs_1.of)(Actions.copyFilesSuccessAction({
                files: payload.files,
                target: payload.target
            }))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.copyFilesFailureAction((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
        }));
    }
    return { fetchTree, copyFiles };
}
exports.default = default_1;
//# sourceMappingURL=epics.js.map